"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseISODate = exports.getDurationTime = exports.getDateRange = exports.getCallDuration = exports.formatMilliseconds = exports.formatDateToDayFull = exports.formatDate = exports.convertTimeStringToTimeNumber = void 0;
var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));
var _isInteger2 = _interopRequireDefault(require("lodash/isInteger"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _getUnixTime = _interopRequireDefault(require("date-fns/getUnixTime"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _ruLocale = _interopRequireDefault(require("./ruLocale"));
var convertTimeStringToTimeNumber = exports.convertTimeStringToTimeNumber = function convertTimeStringToTimeNumber(timeString) {
  return Math.round(new Date(timeString).getTime() / 1000);
};

/**
 * Форматирует дату с нашей локалью
 * @param {string|Date} date YYYY-MM-DD
 * @param {string} formatToken dd MMM
 * @returns {string} 2020-04-25 -> 25 апр
 */
var formatDate = exports.formatDate = function formatDate(date, formatToken) {
  if (!date) return '';
  // Safari не конвертирует дату в формате YYYY-MM-DD, поэтому преобразуем
  // Регулярное выражение для проверки формата 'YYYY-MM-DD HH:MM:SS +/-HHMM'
  var regexStringDate = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?: \+\d{4})?$/;
  if (typeof date === 'string' && regexStringDate.test(date)) {
    return (0, _format["default"])(new Date(date.replace(/-/g, '/')), formatToken, {
      locale: _ruLocale["default"]
    });
  }
  return (0, _format["default"])(new Date(date), formatToken, {
    locale: _ruLocale["default"]
  });
};

/**
 * Форматирует дату полностью, например 23 сентября 2018
 * @param date YYYY-MM-DD
 * @returns {string}
 * @deprecated используй formatDate
 */
var formatDateToDayFull = exports.formatDateToDayFull = function formatDateToDayFull(date) {
  return formatDate(date, 'd MMMM yyyy');
};

/**
 * Возвращает время для таймера в unixtime
 * @param {object} props
 * @param {number?} props.seconds
 * @returns {string} unix
 */
var getDurationTime = exports.getDurationTime = function getDurationTime(_ref) {
  var _ref$seconds = _ref.seconds,
    seconds = _ref$seconds === void 0 ? 0 : _ref$seconds;
  var duration = new Date().setHours(0, 0, seconds, 0);
  return duration;
};

/**
 * Возвращает разницу между двумя unix timestamp
 * @param {string} answeredAt
 * @param {string} finishedAt
 * @returns {number}
 */
var getCallDuration = exports.getCallDuration = function getCallDuration(answeredAt, finishedAt) {
  if (!(0, _isInteger2["default"])(answeredAt)) {
    return -1;
  }
  var current = new Date();

  // @ts-ignore
  var now = (0, _isFunction2["default"])(Date.getServerTime) ?
  // @ts-ignore
  Date.getServerTime() // Syncer of CRM server time
  : (0, _getUnixTime["default"])(current);
  var finishedAtOrNow = finishedAt || now;
  var seconds = finishedAtOrNow - answeredAt;
  return seconds;
};
var parseISODate = exports.parseISODate = function parseISODate(dateISO) {
  if (!dateISO) {
    return '';
  }
  var parsed = (0, _parseISO["default"])(dateISO);
  if ((0, _isValid["default"])(parsed)) {
    return formatDate(parsed, 'dd MMM yyyy');
  }
  return '';
};

/**
 * Возвращается строка с диапазоном дат и количество ночей
 * @param {string} startDate
 * @param {string} endDate
 * @param {number} nights
 * @returns {string}
 */

var getDateRange = exports.getDateRange = function getDateRange(startDate, endDate, nights) {
  return "".concat(startDate, " - ").concat(endDate, ", ").concat(nights);
};

/**
 * Переводит миллисекунды в дни, часы и минуты
 * @param {number} milliseconds
 * @returns {string} "5д 10ч 33м"
 */
var formatMilliseconds = exports.formatMilliseconds = function formatMilliseconds(milliseconds) {
  var minutes = Math.floor(milliseconds / (1000 * 60)) % 60;
  var hours = Math.floor(milliseconds / (1000 * 60 * 60)) % 24;
  var days = Math.floor(milliseconds / (1000 * 60 * 60 * 24));
  return minutes || hours || days ? [days ? "".concat(days, "\u0434") : '', hours ? "".concat(hours, "\u0447") : '', minutes ? "".concat(minutes, "\u043C") : ''].filter(Boolean).join(' ') : '0м';
};